import { __awaiter } from "tslib";
import React, { createContext, useContext, useEffect, useState } from 'react';
import { requestWrapper } from '../api/requestWrapper';
import { getTransformedRestoreId, getTransformedWorkingHours } from '../data/chat';
import { getCountryCodes, getCountryCodesAndFeatureData, getCountryCodesAndRegions, mergeAndGetMarkets } from '../data/markets';
import { useChatClient } from '../hooks/useChatClient';
import { RequestMethodEnum, RegionEnum } from '../components/SupportHelpBot/types';
export const ChannelDataContext = createContext(undefined);
export const ChannelDataStateProvider = ({ children }) => {
    const client = useChatClient();
    const marketsInitState = [];
    const workingHoursInitState = [];
    const restoreIdInitState = { eu: '', ap: '', us: '' };
    const [markets, setMarkets] = useState(marketsInitState);
    const [workingHours, setWorkingHours] = useState(workingHoursInitState);
    const [restoreId, setRestoreId] = useState(restoreIdInitState);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const getMarkets = () => __awaiter(void 0, void 0, void 0, function* () {
            const marketsResponse = yield getMarketsResponse(client);
            const countryCodesAndRegions = getCountryCodesAndRegions(marketsResponse);
            const countryCodes = getCountryCodes(countryCodesAndRegions);
            const chatExpFeatures = yield getChatExpFeature(client, countryCodes);
            const countryCodesAndFeatureData = getCountryCodesAndFeatureData(chatExpFeatures);
            const markets = mergeAndGetMarkets(countryCodesAndRegions, countryCodesAndFeatureData);
            setMarkets(markets);
        });
        const getWorkingHours = () => __awaiter(void 0, void 0, void 0, function* () {
            const workingHoursResponse = yield getWorkingHoursResponse(client);
            const workingHours = getTransformedWorkingHours(workingHoursResponse);
            setWorkingHours(workingHours);
        });
        const getRestoreId = () => __awaiter(void 0, void 0, void 0, function* () {
            const restoreIdResponse = yield getRestoreIdResponse(client);
            const restoreId = getTransformedRestoreId(restoreIdResponse);
            setRestoreId(restoreId);
        });
        Promise.all([getMarkets(), getWorkingHours(), getRestoreId()]).then(() => {
            setIsLoading(false);
            return null;
        }).catch(doNothing);
    }, []);
    const contextValue = {
        isLoading,
        data: {
            markets,
            workingHours,
            restoreId
        }
    };
    return (React.createElement(ChannelDataContext.Provider, { value: contextValue }, children));
};
export const useChannelDataState = () => {
    const value = useContext(ChannelDataContext);
    if (!value)
        throw new Error('cannot get ChannelData state manager as it has not been provided');
    return value;
};
const getMarketsResponse = (client) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield requestWrapper(client, RequestMethodEnum.GET, 'v1/markets'));
});
const getChatExpFeature = (client, markets) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield requestWrapper(client, RequestMethodEnum.GET, 'v1/chat/exp/feature', { markets }, [RegionEnum.EU]));
});
const getWorkingHoursResponse = (client) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield requestWrapper(client, RequestMethodEnum.GET, 'v1/chat/working-hours'));
});
const getRestoreIdResponse = (client) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield requestWrapper(client, RequestMethodEnum.GET, 'v1/chat/restore-id'));
});
const doNothing = () => { };
